import { Box } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useQuotationContext } from '../contexts/QuotationContext';
import { getAllQueryParams } from '../helpers/queryparam';
import { getTextByProduct } from '../services/productMeta';
import ActionPanel from './ActionPanel';
import CouponForm from './CouponForm';
import ErrorMessagePanel from './ErrorMessagePanel';
import FormPanel from './FormPanel';
import ResultPanel from './ResultPanel';
import TermAndConditions from './TermAndConditions';

const QuotationWidget = () => {
  const { activeProduct, productGroups, products, variables } =
    useQuotationContext();
  const { type, defaultCoupon, style } = getAllQueryParams();
  const { nameKey, descriptionKey } = getTextByProduct(type);
  const intl = useIntl();

  if (!activeProduct) {
    return null;
  }

  return (
    <Box width="100%">
      <Helmet>
        <title>
          {intl.formatMessage({
            id: nameKey,
          })}
          {intl.formatMessage({
            id: 'productMeta.title',
          })}
        </title>
        <meta
          name="description"
          content={intl.formatMessage({
            id: descriptionKey,
          })}
        />
      </Helmet>

      <Box display="grid" alignItems="stretch" p={1.5} gridGap={16}>
        <FormPanel products={products} variables={variables} />

        {style !== 'formOnly' && (
          <>
            <ResultPanel productGroups={productGroups} />

            <CouponForm
              couponCode={defaultCoupon ? defaultCoupon.toUpperCase() : ''}
            />
            <ErrorMessagePanel />

            <ActionPanel products={products} />

            <TermAndConditions products={products} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default QuotationWidget;
